export default __webpack_public_path__ + "static/media/benefit1.8c48cfb4.png";